import BaseDrawingService from './BaseDrawingService';

class NewDrugsDrawingService extends BaseDrawingService {
    parseData(data) {
        const parsedData = {};

        Object.keys(data).forEach((dataKey) => {
            const splitRevenues = [[]];
            let currentRevenuesIndex = 0;

            data[dataKey].forEach((revenue, index) => {
                const previousRevenue = index > 0 ? data[dataKey][index - 1] : null;

                const expectedPreviousQuarter = this.getPreviousQuarter(`${revenue.year} ${revenue.quarter}`);
                const actualPreviousQuarter = previousRevenue
                    ? `${previousRevenue.year} ${previousRevenue.quarter}`
                    : null;

                if (index === 0 || (index > 0 && expectedPreviousQuarter === actualPreviousQuarter) || this.filters.startSyncView) {
                    splitRevenues[currentRevenuesIndex].push(revenue);
                } else {
                    splitRevenues.push([revenue]);
                    currentRevenuesIndex += 1;
                }
            });

            parsedData[dataKey] = splitRevenues;
        });

        return parsedData;
    }

    lineClickEvent(id) {
        super.lineClickEvent(id, 'drug_brand_name', 'brand_name');
    }
}

export default NewDrugsDrawingService;
